import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {Observable} from 'rxjs';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class BusinessAdminService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.BUSINESS_ADMINS(), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.BUSINESS_ADMINS_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.BUSINESS_ADMINS(id));
    }

    universityBusinessAdmin(id): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITY_BUSINESS_ADMIN(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.BUSINESS_ADMINS(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.BUSINESS_ADMINS(id), data);
    }

    detailById(id): Observable<any> {
        return this.getRequest(AppUrl.BUSINESS_ADMIN_DETAIL_BY_ID(id));
    }

    updatePassword(id, data): Observable<any> {
        return this.putRequest(AppUrl.BUSINESS_ADMIN_PASSWORD(id), data);
    }

    updateUniversity(id, data): Observable<any> {
        return this.putRequest(AppUrl.BUSINESS_ADMIN_UPDATE_UNIVERSITY(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.BUSINESS_ADMIN_STATUS(id), data);
    }

    updateProfile(id, data): Observable<any> {
        return this.putRequest(AppUrl.ADMINS_PROFILE_IMAGE(id), data);
    }

    getAdminReportCount(id): Observable<any> {
        return this.getRequest(AppUrl.ADMINS_PROGRESS_REPORT_COUNT(id));
    }

    getAdminsHeadCounsellors(id, data): Observable<any> {
        return this.getRequest(AppUrl.ADMINS_HEAD_COUNSELLORS(id), data);
    }
}
